// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__329pK","emails":"CreateEditClinics_emails__ej2SE","emailTagLabel":"CreateEditClinics_emailTagLabel__VOssH"};